module.exports = function () {
    let result;

    if (!navigator.userAgent || navigator.userAgent.indexOf('Prerender') === -1) {
        result = navigator.geolocation;
    } else {
        result = {}; //Return an empty object for Prerender as it fails
    }

    return result;
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/geolocation/geolocation-factory.js
 **/